import type { MapStateToProps } from 'react-redux';
import { connect } from 'react-redux';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import {
  priceImprovementBlotterAcknowledgeErrorDismissed,
  priceImprovementBlotterAcknowledgeRequested,
} from 'state/blotters/priceImprovement/priceImprovementBlotter.action';
import {
  getAcknowledgementError,
  getSelectionSize,
} from 'state/blotters/priceImprovement/priceImprovementBlotter.selector';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';
import type { ApiError } from 'utils/http/apiErrorHelper';

export type AcknowledgePanelProps = StateProps & DispatchProps;

interface StateProps {
  selectionSize: number;
  error?: ApiError;
}

interface DispatchProps {
  onAcknowledge(): void;
  onErrorDismissed(): void;
}

const mapStateToProps: MapStateToProps<StateProps, {}, AppState> = (appState: AppState): StateProps => ({
  selectionSize: getSelectionSize(appState),
  error: getAcknowledgementError(appState),
});

const mapDispatchToProps = (dispatch: ThunkDispatch): DispatchProps => ({
  onAcknowledge() {
    dispatch(priceImprovementBlotterAcknowledgeRequested());
    logAnalytics.trackEvent('Blotter My price improvements', 'Acknowledge');
  },
  onErrorDismissed() {
    dispatch(priceImprovementBlotterAcknowledgeErrorDismissed());
  },
});

export const connectAcknowledgePanel = connect(mapStateToProps, mapDispatchToProps);
